/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const CreateFileMetadata = /* GraphQL */ `mutation CreateFileMetadata($metadataCreateRequest: CreateFileMetadataInput!) {
  CreateFileMetadata(metadataCreateRequest: $metadataCreateRequest) {
    description
    errors {
      count
      errorDetails
      __typename
    }
    exportStatus
    fileId
    fileName
    fileSize
    headers
    lastModifiedAt
    lastModifiedBy
    operatorsProcessed
    orgId
    recordCount
    rowsProcessedList
    s3Key
    s3OutputKeys
    templateId
    uploadBy
    uploadStatus
    uploadedAt
    validationResults
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFileMetadataMutationVariables,
  APITypes.CreateFileMetadataMutation
>;
export const CreateOrganization = /* GraphQL */ `mutation CreateOrganization($orgRequest: CreateOrganization!) {
  CreateOrganization(orgRequest: $orgRequest) {
    createdAt
    createdBy
    fileTemplateConfig {
      description
      displayName
      headers
      templateId
      __typename
    }
    landingBucketConfig {
      bucketName
      bucketPrefix
      bucketRegion
      __typename
    }
    lastModifiedAt
    lastModifiedBy
    numberOfFiles
    orgId
    orgName
    orgType
    status
    targetColumnMapping
    targetColumns {
      desc
      key
      tagName
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrganizationMutationVariables,
  APITypes.CreateOrganizationMutation
>;
export const CreateUser = /* GraphQL */ `mutation CreateUser($userRequest: CreateUserInput!) {
  CreateUser(userRequest: $userRequest) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const HashAndEncryptFile = /* GraphQL */ `mutation HashAndEncryptFile($processRequest: HashAndEncryptRequest!) {
  HashAndEncryptFile(processRequest: $processRequest) {
    message
    operatorsProcessed
    orgId
    rowsProcessed
    s3OutputKeys
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.HashAndEncryptFileMutationVariables,
  APITypes.HashAndEncryptFileMutation
>;
export const PublishFile = /* GraphQL */ `mutation PublishFile($publishRequest: PublishRequest!) {
  PublishFile(publishRequest: $publishRequest) {
    filesRemoved
    message
    orgId
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PublishFileMutationVariables,
  APITypes.PublishFileMutation
>;
export const UpdateFileMetadata = /* GraphQL */ `mutation UpdateFileMetadata($metadataUpdateRequest: UpdateFileMetadataInput!) {
  UpdateFileMetadata(metadataUpdateRequest: $metadataUpdateRequest) {
    description
    errors {
      count
      errorDetails
      __typename
    }
    exportStatus
    fileId
    fileName
    fileSize
    headers
    lastModifiedAt
    lastModifiedBy
    operatorsProcessed
    orgId
    recordCount
    rowsProcessedList
    s3Key
    s3OutputKeys
    templateId
    uploadBy
    uploadStatus
    uploadedAt
    validationResults
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFileMetadataMutationVariables,
  APITypes.UpdateFileMetadataMutation
>;
export const UpdateOrganization = /* GraphQL */ `mutation UpdateOrganization($updateOrgInput: UpdateOrganizationInput!) {
  UpdateOrganization(updateOrgInput: $updateOrgInput) {
    createdAt
    createdBy
    fileTemplateConfig {
      description
      displayName
      headers
      templateId
      __typename
    }
    landingBucketConfig {
      bucketName
      bucketPrefix
      bucketRegion
      __typename
    }
    lastModifiedAt
    lastModifiedBy
    numberOfFiles
    orgId
    orgName
    orgType
    status
    targetColumnMapping
    targetColumns {
      desc
      key
      tagName
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrganizationMutationVariables,
  APITypes.UpdateOrganizationMutation
>;
export const UpdateValidationResults = /* GraphQL */ `mutation UpdateValidationResults($input: UpdateValidationResultsInput!) {
  UpdateValidationResults(input: $input) {
    fileId
    orgId
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateValidationResultsMutationVariables,
  APITypes.UpdateValidationResultsMutation
>;
